import { render } from "./GoodsListCate3.vue?vue&type=template&id=231b6f1f"
import script from "./GoodsListCate3.vue?vue&type=script&lang=js"
export * from "./GoodsListCate3.vue?vue&type=script&lang=js"

import "./GoodsListCate3.vue?vue&type=style&index=0&id=231b6f1f&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__